import { Outlet, useLocation } from 'react-router-dom';
import BackButton from 'components/BackButton';
import { ROUTE_PATHS } from 'routes/constants';

const EmailStatistics = () => {
  const location = useLocation();

  return (
    <section className={'right-section'}>
      {location.pathname !== ROUTE_PATHS.EMAIL_STATISTICS && <BackButton />}
      <Outlet />
    </section>
  );
};

export default EmailStatistics;
